import React from 'react';
import { Box } from '@mui/material';

interface SimpleGridProps {
  container?: boolean;
  item?: boolean;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  spacing?: number;
  children: React.ReactNode;
  sx?: any;
}

const SimpleGrid: React.FC<SimpleGridProps> = ({
  container,
  item,
  xs,
  sm,
  md,
  lg,
  spacing,
  children,
  sx = {},
  ...props
}) => {
  const containerStyles = container ? {
    display: 'flex',
    flexWrap: 'wrap',
    margin: spacing ? `-${spacing * 4}px` : 0,
    ...sx
  } : {};

  const itemStyles = item ? {
    padding: spacing ? `${spacing * 4}px` : 0,
    width: xs ? `${(xs / 12) * 100}%` : '100%',
    '@media (min-width: 600px)': sm ? {
      width: `${(sm / 12) * 100}%`
    } : {},
    '@media (min-width: 900px)': md ? {
      width: `${(md / 12) * 100}%`
    } : {},
    '@media (min-width: 1200px)': lg ? {
      width: `${(lg / 12) * 100}%`
    } : {},
    ...sx
  } : {};

  return (
    <Box sx={{ ...containerStyles, ...itemStyles }} {...props}>
      {children}
    </Box>
  );
};

export default SimpleGrid;